import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App";
import reportWebVitals from './reportWebVitals';

// import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/collapse";
import "./index.css";
import "./default.css";
import "./style.css";
import "./responsive.css";

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
